module.exports = __webpack_public_path__ + "img/cbrt.d025573.png";